import { useState, type VoidFunctionComponent } from 'react';

import Locator from '../../../../../../shared/Locator';
import { Action } from '../../../../../shared/permissions';
import useHasProjectPermission from '../../../../../shared/permissions/useHasProjectPermission';
import Button from '../../../../generic/Button';
import type { Dependency } from '../../../../../../shared/dependenciesV2';

import DependencyDetails from './DependencyDetails';
import { DependencyDetailsEdit } from './DependencyDetailsEdit';
import MalwareIssueBanners from './MalwareIssueBanners';

import styles from '../DependencyDrawer.module.less';

type Props = {
  dependency: Dependency;
};

const DependencyDetailsContainer: VoidFunctionComponent<Props> = ({ dependency }) => {
  const canEditDetails = useHasProjectPermission(Locator.parsePackageString(dependency.locator), Action.Edit);

  const [isEditing, setIsEditing] = useState(false);
  const toggleEditing = () => setIsEditing(!isEditing);

  return (
    <>
      <MalwareIssueBanners issues={dependency.issues} />

      <div className={styles.detailsHeaderContainer}>
        <div className={styles.header}>Package Details</div>
        {canEditDetails && (
          <Button type="secondary" onClick={toggleEditing}>
            {isEditing ? 'Go back' : 'Edit'}
          </Button>
        )}
      </div>

      {isEditing ? (
        <DependencyDetailsEdit dependency={dependency} toggleEditing={toggleEditing} />
      ) : (
        <DependencyDetails dependency={dependency} />
      )}
    </>
  );
};

export default DependencyDetailsContainer;
